import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const categorySlice = createSlice({
  name: "category",
  initialState: {
    categoryItems: [],
    category: {},
    loading: false,
    error: null,
  },
  reducers: {
    setCategoryItems: (state, action) => {
      state.categoryItems = action.payload.data || [];
      state.loading = false;
    },
    setCategory: (state, action) => {
      state.category = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectCategoryLoading = (state) => state.category.loading;
export const selectCategoryError = (state) => state.category.error;
export const selectCategoryItems = (state) => state.category.categoryItems;
export const selectCategory = (state) => state.category.category;

// Export the reducer to include in the store
export const { setCategory, setCategoryItems } = categorySlice.actions;
export default categorySlice.reducer;
